'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  PARTICIPANT_TABS,
  ROUTE_BY_PARTICIPANT
} from '@/components/ParticipantTabs/ParticipantTabs.constants';
import { DropdownArrowIcon } from '@/components/ui/Icons/Icons';
import { ParticipantEnum } from '@/constants/common';
import { useParticipant } from '@/providers/ParticipantProvider';

import * as S from './ParticipantDropdown.styles';

export const ParticipantDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { participant, setParticipant } = useParticipant();
  const { t } = useTranslation();
  const { push } = useRouter();

  const handleSelect = (newParticipant: ParticipantEnum) => {
    if (newParticipant === participant) {
      setIsOpen(false);
      return;
    }
    sendGTMEvent({
      event: 'switcher_tab_clicked',
      tab:
        newParticipant === ParticipantEnum.VACANCY ? 'job_listings' : 'resumes'
    });
    setParticipant(newParticipant);
    push(ROUTE_BY_PARTICIPANT[newParticipant]);
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && <S.Backdrop onClick={() => setIsOpen(false)} />}

      <S.Wrapper>
        <S.Trigger
          onClick={() => setIsOpen(prev => !prev)}
          aria-expanded={isOpen}
          aria-haspopup="listbox"
          data-cy="participant-dropdown-trigger"
        >
          <S.OptionLabel>
            {t(`Header.nav_link_${participant.toLowerCase()}`)}
          </S.OptionLabel>
          <S.Arrow $isOpen={isOpen}>
            <DropdownArrowIcon />
          </S.Arrow>
        </S.Trigger>

        {isOpen && (
          <S.Dropdown role="listbox">
            {PARTICIPANT_TABS.map(tab => (
              <S.Option
                key={tab.id}
                role="option"
                $isSelected={tab.participant === participant}
                aria-selected={tab.participant === participant}
                onClick={() => handleSelect(tab.participant)}
                data-cy={`participant-dropdown-option-${tab.id}`}
              >
                <S.OptionLabel>
                  {t(`Header.nav_link_${tab.participant.toLowerCase()}`)}
                </S.OptionLabel>
              </S.Option>
            ))}
          </S.Dropdown>
        )}
      </S.Wrapper>
    </>
  );
};
